import React from 'react';
import { Badge } from 'reactstrap';

export default function Tags(tags) {
  const showTags = (blogTags) => {
    if (!blogTags) {
      return;
    }

    return blogTags.map((tag) => (
      <Badge key={tag} pill className="me-2 stag-badge">{tag.trim()}</Badge>
    ));
  };

  return (
    <div>{showTags(tags)}</div>
  );
}
